import { useEffect } from "react";

export const useScrollToElement = (elementId: string) => {
  useEffect(() => {
    const element = document.getElementById(elementId);
    element?.scrollIntoView({ behavior: 'smooth' });
  }, [elementId]);
} 